import { render } from "./MdContentTableTypeList.vue?vue&type=template&id=5c8ccfe2&scoped=true"
import script from "./MdContentTableTypeList.vue?vue&type=script&lang=js"
export * from "./MdContentTableTypeList.vue?vue&type=script&lang=js"

import "./MdContentTableTypeList.vue?vue&type=style&index=0&id=5c8ccfe2&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8ccfe2"]])

export default __exports__